import React, { useState, useRef } from 'react';
import { Flex, Text, Box, Image } from 'rebass';
import Wrapper from './Wrapper';
import CollapsibleSection from './CollapsibleSection';
import { FaRegCircleQuestion } from "react-icons/fa6";
import GiftCertificateField from 'babys-first-year/GiftCertificateField';
import ProductPackagesListing from './ProductPackagesListing';
import BookMockUp from './assets/BookMockUp.png';
import Naapa from './assets/Naapa-award-winner.png';
import ResponsiveReactPlayer from 'story-media/medium-types/ResponsiveReactPlayer';

// const FAQSections = [
//     {
//         section: "About the Baby Yearbook Experience",
//         faqs: [
//             {
//                 question: "How does the video-in-a-book feature actually work?",
//                 answer: "When you design your beautiful hardcover book, we automatically place unique QR codes on the pages next to your memories. When you (or a loved one) scan a QR code with a phone or tablet, the video you saved for that moment instantly plays on the screen. It turns your book into a living, moving time capsule."
//             },
//             {
//                 question: "What exactly is a 'Memory'?",
//                 answer: "A Memory, also called a Story, is a single entry in your baby's book and made up of any combination of text, photos, and video. It can be as simple as a photo or video. Or it can be several of each type. You can also add captions for each one, or write or dictate longer thoughts — those will be transcribed and tidied with AI. When you create your book, each memory will be a story, inside a chapter."
//             },
//             {
//                 question: "Can I start during pregnancy?",
//                 answer: "Absolutely! While most of your memories will come after your baby is born, pregnancy is a special chapter in your child’s story — one they’ll love hearing about someday. This is the perfect time to capture moments like: The story behind choosing their name and its meaning, Ultrasound pictures and your thoughts when you first saw them, How you felt hearing their heartbeat for the first time, Funny, emotional, or unexpected moments along the way."
//             },
//             {
//                 question: "How long can a Memory be? What are the limitations?",
//                 answer: "Memories can be any length and can be made up of any combination of text, pictures and video, in any order you choose."
//             },
//             {
//                 question: "Can I start after the baby is born and back-date Memories?",
//                 answer: "Yes! It's never too late to start. Our app makes it easy to back-date your memories, so you can fill in moments from previous weeks or months. Everything will be automatically organized chronologically in your book."
//             },
//             {
//                 question: "Can I do this even if my baby is older than 1?",
//                 answer: "Of course. While many people create a 'Baby's First Year' book, you can create a book for a child of any age. With our ease of use, many parents are already planning to create a series of books for future years as well."
//             },
//             {
//                 question: "Can my partner or grandparents add memories too?",
//                 answer: "Yes! You can easily invite your partner, grandparents, or other loved ones to contribute their own photos, videos, and stories to the book, creating an incredibly rich and multi-voiced keepsake. Imagine, decades later, being able to view a video — not just any video with grandparents in it but one in which they’re telling a story to the baby — when they were still a baby. In their special book."
//             }
//         ]
//     },
//     {
//         section: "Plans, Pricing & Subscriptions",
//         faqs: [
//             {
//                 question: "How does the special bundle plan auto-renew?",
//                 answer: "The special bundle offers huge savings by including the first year of a yearly plan along with your first book. That plan will auto-renew at the rate of the yearly subscription plan at the time of renewal. In addition, you’ll receive a 25% discount on the price of any extra books you order (like one for each set of grandparents)."
//             },
//             {
//                 question: "What am I getting with the Free account?",
//                 answer: "Our free plan is a great way to explore how Baby Yearbooks works. You can create up to 3 'Memories,' invite a loved one to contribute, and see all our features in action. Upgrade your account when you’re ready in the app."
//             },
//             {
//                 question: "What does the subscription (Monthly/Yearly) actually pay for?",
//                 answer: "Your subscription is for the full Baby Yearbooks digital experience. It gives you unlimited app access to create and store an unlimited number of memories (photos, videos, and text), including memories from your contributors. The physical hardcover book is purchased separately (unless you choose the Special Bundle Plan)."
//             },
//             {
//                 question: "What happens to my memories if my subscription ends or I cancel?",
//                 answer: "Your memories are safe! Once your subscription ends, your account will still be accessible. You will be able to log in, edit pre-existing memories and purchase books. However, once your subscription has expired, you will be unable to add new memories."
//             },
//             {
//                 question: "Can I cancel my subscription anytime?",
//                 answer: "Yes, you can cancel your subscription at any time. If you cancel, your subscription will remain active until the end of your current billing period."
//             },
//             {
//                 question: "Do I have to finish my book in exactly one year?",
//                 answer: "Not at all! Life with a baby is unpredictable. You can take as long as you need. Your subscription will renew automatically (we’ll let you know by email shortly before it’s due to renew). And if all you want to do is edit pre-existing memories as you fine-tune your book, you don’t even need a subscription. You can also purchase your book anytime without a subscription."
//             },
//             {
//                 question: "How does your price compare with other photo book services?",
//                 answer: "When you compare apples to apples (hardcover, 8.5\"x11\" size, 75+ premium pages), our book price is highly competitive. Even better, those services don't even offer our most magical features: integrated video, storytelling and collaborative contributions. The lasting value of a keepsake that truly comes to life is unmatched."
//             }
//         ]
//     },
//     {
//         section: "The Hardcover Book",
//         faqs: [
//             {
//                 question: "What is the quality of the physical book?",
//                 answer: "You will receive a beautiful 8.5\" x 11\" hardcover book printed on the highest quality coated paper with rich color ink to ensure your photos and stories look stunning for generations. It’s a premium keepsake designed to be a family treasure."
//             },
//             {
//                 question: "How many pages are included in the book?",
//                 answer: "Our base price includes 75 pages. If you have more memories to share, you have the option of making the book bigger — up to 500 pages. Extra pages can be added for a small per-page fee when you place your order."
//             },
//             {
//                 question: "Can I preview my full book before I order it?",
//                 answer: "Yes! Before you order, you'll have the chance to preview the entire layout of your book. You’ll be able to see how your stories look on each page and will have lots of options to fine-tune each one the way you’d like to see it."
//             }
//         ]
//     },
//     {
//         section: "Gifting a Baby Yearbook",
//         faqs: [
//             {
//                 question: "How will the recipient get their gift?",
//                 answer: "After your purchase, you will receive a beautiful, personalized gift certificate as a PDF via email. You can print it out to give in person (it’s perfect for a baby shower!) or easily share it digitally via email or messaging."
//             },
//             {
//                 question: "When does the 1-year gift subscription begin?",
//                 answer: "The 1-year subscription begins on the day the recipient redeems their unique gift certificate code, not on the day you purchase it. They can start their memory book whenever they are ready."
//             },
//             {
//                 question: "What if I want to create the book myself and gift the finished product?",
//                 answer: "That's a wonderful and very personal gift! To do this, simply choose the 'For My Baby' option instead of 'Give a Gift.' You can use our platform to create the entire book, and when you're finished, you can order the hardcover book and have it shipped to yourself or the recipient."
//             }
//         ]
//     },
//     {
//         section: "Account, Privacy & Support",
//         faqs: [
//             {
//                 question: "How will my private information be stored?",
//                 answer: "Your privacy is our priority. All data is securely stored using encrypted servers. We will never use or share your information. For further details, please see our Privacy Policy."
//             },
//             {
//                 question: "Where do you ship your books?",
//                 answer: "We currently ship to the United States and Canada. We are working on expanding our shipping destinations!"
//             },
//             {
//                 question: "What if I need help or have a technical issue?",
//                 answer: "We're here for you! If you have any questions or need assistance, please visit our Contact Us page to get in touch with our friendly support team. We'll be happy to help you."
//             }
//         ]
//     }
// ];

const faqs = [
    {
        question: "How does your price compare with photobooks?",
        answer: `We invite you to compare! Our price is highly competitive — often even lower than others’ discounted pricing!

And unlike traditional photo books, ours includes video too, as well as other special features!

Other services may offer lower-cost options with smaller sizes, soft covers, fewer pages, or lower-quality paper, but those compromises come at the expense of quality.

        Compare these specs: <ul style="margin-left: -25px !important;
    margin-top: 0px;
    margin-bottom: 0px;">
<li>Hardcover book</li>
<li>Photo-quality matte pages</li>
<li>8.5" x 11" size</li>
<li>75 pages</li>
</ul>

A few dollars saved today won’t compare to the lasting value of a book you’ll cherish forever.

At Baby Yearbooks, we make it easy to create a beautiful keepsake—at a great price!
        `
    },
    {
        question: "Is it simple enough for busy new parents?",
        answer: `Yes. Quick capture in seconds, edit at any time later. Reminders to stay on track. Specialty pages like Milestones and Watch Me Grow. 
        We also handle the printing and shipping.
        `
    },
    {
        question: "Do I start the book for them?",
        answer: `No. You purchase the gift; parents create their own account, own the book and can invite you to contribute anytime.
        `
    },
    {
        question: "Will my stories appear in the printed book?",
        answer: `If your daughter or daughter-in-law sends you a link and you create a story using that link, you will be in the book!

        We encourage grandparents to not only upload pictures or video, but to also do a video narration, speaking to your grandchild.

        Just imagine how your grandchild will feel in 30 years, watching grandma or grandpa speaking to them when they were a baby 😄
        `
    },
    {
        question: "When does the subscription start?",
        answer: `Not to worry 😄

 You don’t need to wait to buy your gift. The subscription doesn’t begin when you purchase the gift certificate. It only starts when Mom creates her account.

And if she’s still expecting, we’ve thought of that too! Her subscription will be automatically extended to include those extra months before the baby arrives.
        `
    },
    {
        question: "What is the subscription for? What happens when it ends?",
        answer: `The 12 month subscription gives Mom everything she needs to easily create a beautiful Baby Yearbook, one little moment at a time.

She can:
<ul style="    margin-left: -25px !important;
    margin-top: 0px;
    margin-bottom: 0px;">
<li>Add a few photos or short videos every couple of weeks — quick and simple, so it never feels like a big project</li>
<li>Edit and fine-tune stories anytime before printing</li>
<li>Get gentle reminders (on her own schedule) to capture milestones before they’re forgotten</li>
<li>Record Milestone dates in a special section and page made just for them</li>
<li>Try our adorable Watch Me Grow feature — moms tell us they love it!</li>
<li>Add short voice or video narrations that are automatically transcribed</li>
<li>Organize everything into chapters</li>
<li>Even invite others, like grandparents, to contribute a story</li></ul>

And we’re always adding new features designed to make preserving baby’s story even better.

When the subscription ends, nothing disappears. Mom can still log in, revisit her stories, make edits, download content, and order more books anytime.

And the QR codes will continue to link to our server at Amazon or to an alternate storage service of your choice (e.g. YouTube).
        `
    },
];

const ReadyToPurchase = ({
    onStepUp,
    onStepDown,
    quantity,
    setRequiresQuantity,
    calculatedPricing,
    generateInvoice,
    orderSummary,
    firePostMemberEvent,
    member,
    email,
    setEmail,
    isForMyBaby,
    isFromPaywall,
    hideSkip,
    currentChildJournalId,
    nextButtonText,
    imageURL = Naapa,
    setStatus,
    ...props
}) => {
    const ref = useRef(null);
    const [openQuestion, setOpenQuestion] = useState(null);

    function sendEmail() {
        const title = `Question about Baby Yearbooks`;

        const mailto = `mailto:hello@babyyearbooks.com?subject=${encodeURIComponent(title)}`;

        window.open(mailto, '_blank')
    }

    return (<Wrapper
        hideSkip={hideSkip}
        onSubmit={onStepUp}
        onBack={onStepDown}
        bg="aliceBlue"
        nextButtonText={nextButtonText}
    >
        <Flex justifyContent="center" alignItems="center" m="auto" maxWidth={['100%', '100%', 480]} >
            {/* <Image src={BookMockUp} mx="auto" mt={2} mb={4} maxWidth={['100%', '100%', 480]} /> */}
            <ResponsiveReactPlayer
                playerWrapper={{ width: '100%' }}
                height='330px'
                playing={true}
                muted={true}
                controls={false}
                loop
                preload="auto"
                playsinline={true}
                url="https://player.vimeo.com/video/1054560556"
                config={{
                    file: {
                        attributes: {
                            preload: true
                        }
                    },
                    vimeo: { preload: true }
                }}
            />
        </Flex>
        <Box m="auto" mt="1.7%" width={['92%', '92%', '480px']} minWidth={['max-width', 480]}>
            <ProductPackagesListing
                currentChildJournalId={currentChildJournalId}
                isForMyBaby={isForMyBaby}
                // onStepUp={onStepUp}
                {...props}
            />

            {isForMyBaby && !props?.isFromRedeemCertificate && <GiftCertificateField setStatus={setStatus}  {...props} />}
            <Image src={BookMockUp} mx="auto" mb={4} maxWidth={['100%', '100%', 480]} />
        </Box>
        {!isFromPaywall && <>
            <Box width="100vw" pb="40px" >
                <Flex flexDirection="column" maxWidth={480} alignItems="center" justifyContent="center" m="auto" width={['92%', '92%', '100%']} >
                    <Box>
                        <Text my="2%" color="codGrey"
                            fontFamily="Bitter"
                            fontSize={30}
                            lineHeight="120%"
                            letterSpacing="-0.18px"
                            textAlign="left">FAQ's</Text>
                        {/* {FAQSections.map(({ faqs, section }) => {
                        return <Box key={section} mb="20px">
                            <Text mb="3.9%" width="100%"
                                bg="#F5EEF8"
                                p={4}
                                color="codGrey"
                                fontFamily="Bitter"
                                fontSize={30}
                                lineHeight="120%"
                                letterSpacing="-0.18px"
                                textAlign="left">{section}</Text> */}
                        {faqs.map(({ question, answer }, index) => <CollapsibleSection index={index} isOpen={openQuestion} setIsOpen={setOpenQuestion} label={question} >
                            <Text sx={{
                                color: "#4F4F4F",
                                fontFamily: "Poppins",
                                fontSize: "16px",
                                fontStyle: "normal",
                                fontWeight: 400,
                                lineHeight: "150%",
                                whiteSpace: 'pre-line'
                            }}
                                dangerouslySetInnerHTML={{ __html: answer }}
                            />
                        </CollapsibleSection>)}
                        {/* </Box>
                    })} */}
                    </Box>
                </Flex>
            </Box>
            <Flex justifyContent="center" alignItems="center" my="20px">
                <FaRegCircleQuestion color="#0E0E0E" size={20} />
                <Text
                    ml={1}
                    color="codGrey"
                    fontFamily="Poppins"
                    fontWeight={400}
                    letterSpacing="-0.096px"
                    fontSize={16}
                    lineHeight="120%"
                >
                    Have any more questions? <Text
                        as="span"
                        fontWeight={600}
                        color="#9B59B6"
                        onClick={sendEmail}
                        sx={{
                            textDecorationLine: 'underline',
                            cursor: 'pointer'
                        }}>Contact Us.</Text>
                </Text>
            </Flex>
        </>}
        {/* <Reviews reviews={userReviews} /> */}
        {/* <MoneyBackGuranteComponent /> */}
        {/* </Box> */}
    </Wrapper>
    );
};

export default ReadyToPurchase;
